import { api } from "@api/api";
import { Discount } from "@modules/discounts/types";
import { DiscountFormValues } from "@modules/discounts/validations";

export async function createDiscountService(
  data: DiscountFormValues
): Promise<Discount> {
  const { data: response } = await api.post<Discount>("/v1/discount_admin/", data);

  return response;
}
